import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useRouter from 'common/hooks/use-router';

import Table from 'common/components/Table/Table';
import PageHeader from 'common/components/PageHeader/PageHeader';
import Button from 'common/components/Button/Button';

import usePreparatorArea from 'preparatorAreas/contexts/preparatorAreas';

const PreparatorAreaList = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const {
    fetchItems: fetchPreparatorAreas, items: preparatorsAreas, isFetching, pageCount, remove, filters, setFilter,
    itemsCount,
  } = usePreparatorArea();

  const handleDelete = useCallback(async (row) => {
    await remove(row.original.id);
    await fetchPreparatorAreas();
  }, [remove, fetchPreparatorAreas]);

  const handleEdit = useCallback((row) => router.push(`/preparator-areas/edit/${row.original.id}`), [router]);

  const columns = useMemo(() => [
    {
      Header: t('preparatorAreas.id'),
      accessor: 'id',
    },
    {
      Header: t('common.name'),
      accessor: 'name',
      filterName: 'name_contains',
    },
    {
      Header: t('common.actions'),
      className: 'table-actions',
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => (
        <>
          <Button
            onClick={() => handleEdit(row)}
            icon="fa-pencil-alt"
            color="primary"
            transparent
          />
          <Button
            onClick={() => handleDelete(row)}
            icon="fa-trash-alt"
            color="danger"
            confirm
            transparent
            confirmMessage={t('preparatorAreas.confirmDelete')}
          />
        </>
      ),
    },
  ], [t, handleDelete, handleEdit]);

  return (
    <>
      <PageHeader
        title={t('menu.listPreparatorAreas')}
        link={{ url: '/preparator-areas/add', icon: 'plus', label: t('preparatorAreas.addPreparatorArea') }}
      />
      <section className="section list-page">
        <Table
          data={preparatorsAreas}
          columns={columns}
          fetchData={fetchPreparatorAreas}
          isFetching={isFetching}
          pageCount={pageCount}
          filters={filters}
          setFilter={setFilter}
          itemsCount={itemsCount}
        />
      </section>
    </>
  );
};

export default PreparatorAreaList;
